export const notifyMessage = {
  errorMessage: {
    FILE_DOWNLOAD_FAILED:
      'Error: Unable to download the file. Please refresh and try again.',
    FILE_UPLOAD_MISSING: 'Error: File must be uploaded to continue',
    FILE_UPLOAD_ASK_EXTERNAL_BUYER:
      'Error: Please upload file in .xls/.xlsx/.csv format to continue',
    FILE_UPLOAD_ASK_IPSOS:
      'Error: Please upload file in .csv format to continue',
    FILE_UPLOAD_ERROR_GENERIC:
      'Error: Please upload file in <FILE_EXTENSION> format to continue',
    INVALID_CREDENTIALS: 'Please check your email and password and try again',
    NO_DATA_ERROR:
      'Error:  Unable to retrieve data. Please refresh and try again',
    INVALID_PSID_FILE:
      'PSID file is empty / invalid. Please update to continue',
    UPLOAD_PSID_FILE: 'Please upload respondent list to continue',
    API_ERROR: 'Something went wrong, try again',
    EMPTY_PSID_ERROR: 'Invald or empty PSID list in uploaded file',
    SERVER_ERROR:
      'Error: An unexpected server error has occurred. Please refresh and try again',
    COUNTRY_MISSING: 'Error: Please select a country.',
    QUALIFICATION_MISSING: 'Error: Please select a qualification.',
    INVALID_EMAIL: 'Please enter a valid email address',
    EPC_REPORT: {
      NO_DATA_ERROR:
        'Error:  No record has been found for selected buyer. Please add to continue',
    },
    INVALID_DATE_RANGE: 'Please select the date range',
    NO_BUYER_SELECTED: 'Please Select Buyers from the List!',
    NO_SUPPLIER_SELECTED: 'Please Select Suppliers from the List.',
    NO_STATUS_SELECTED: 'Please Select a Status.',
    NO_RESPONDENT_STATUS_SELECTED: 'Please Select a Respondent Status.',
    PSID_REPORT: {
      NO_DATA_FOUND:
        'Error: No record has been found. Please update to continue',
      INVALID_ENTRY: 'Error: Invalid entry. Please update to continue',
    },
    OPERATION_UNAVAILABLE: 'Error: Operation unavailable',
    COMPANIES_NOT_FOUND:
      'Error: Unable to retrieve Companies. Please refresh and try again',
    INVOICE_REGENERATE_FAILED:
      'Error: Unable to regenerate invoice. Please refresh and try again',
    ALL_FIELDS_REMAINING:
      'Error: All fields must be populated. Please update to continue',
    URL_UPDATE: 'Error:  Please update URL to continue',
    NO_ZIP_CODE_FOUND: 'No Zipcode Found',
    INVALID_LOCATION_CODE_FILE:
      'The file has been imported but it contains invalid ZIP/Post code(s).\nIf you use the “DOWNLOAD CURRENT FILE” option, we will indicate which Postcodes are ‘valid’ and which are ‘invalid’.',
    INVALID_FSA_CODE_FILE:
      'The file has been imported but it contains invalid FSA code(s). \nIf you use the "DOWNLOAD CURRENT FILE" option, we will indicate which FSA codes are `valid` and which are `invalid`.',
    INVALID_CHILDREN_AGES: 'Invalid children quota ages "from" - "to"',
    INVALID_CHILD_AGE_GENDER_QUALIFICATION_NOT_FOUND:
      'Child age gender qualification not found',
    INVALID_CHILD_AGE_GENDER_SURVEY_QUALIFICATION_NOT_FOUND:
      'Child age gender survey qualification not found',
    INVALID_NO_CHILDREN_QUALIFICATION_FOUND: 'No children qualification found',
    INVALID_CHILDREN_QUALIFICATION_NOT_FOUND:
      'Children qualification not found',
    INVALID_MULTIPLE_CHILDREN_QUALIFICATION:
      'Invalid survey children qualification, more than one set',
    QUOTA_MODAL: {
      EMPTY_RANGE_ROW: 'Row cannot be left empty.',
      INVALID_RANGE_YEAR_MONTH:
        'Age cannot be greater than 17 in years, or 47 in months.',
      MISSING_GENDER: 'Gender must be selected. Please update to continue',
    },
    SURVEY_LAUNCH: {
      EMPTY_LIVE_URL: 'Please enter valid Live URL',
      EMPTY_SCHEDULE_LAUNCH:
        'Error: Please update the project launch date / time to continue.',
      LIVE_URL_ERR_FROM_API:
        'Your survey requires a valid Live URL before launching. Please add a Live URL before retrying.',
      UNIQUE_BUYER_LINKS_NOT_UPLOAD:
        'Please upload Unique Buyer entry links to continue.',
      CPI_COMPENSATION_CONFIRMED:
        'CPI and Compensation must be confirmed before proceeding',
      PRICE_OVERRIDE_NOT_FOUND:
        'Surveys on this account require Price Override.  Please set via the Define / Edit Audience page or Supplier Allocations view',
      INVALID_BILLING_NUMBER_RULE:
        '<b>Invalid billing number.</b> <br> The number should follow the format of this example: <b>:BILLING_NUMBER_EXAMPLE</b> <br> Use the tooltip beside the billing input text to check the rules and try again.',
      INVALID_BILLING_NUMBER: 'Please add a valid billing number',
      FEOT_INTERVAL_BIGGER_THAN_FIELD_TIME:
        'The desired interval value cannot be bigger than the field time value.',
      BPM_REQUIRED_ON_LAUNCH:
        'Having a Project Manager assigned is required to launch this survey.',
      BPM_REQUIRED_ON_UPDATE:
        'Having a Project Manager assigned is required to update this survey.',
      RESPONDENT_LIST_MISSING:
        'Respondent List is missing or empty. Include survey must have a Respondent list or Survey Grouping list.',
    },
    MULTICOUNTRY_DRAFT: {
      REJECTED_SURVEYS:
        'The system encountered a problem to create the survey for',
      FOOTER_FINALIZE_AND_LAUNCH:
        'Error: Please click to "Save all Survey as Draft” before Finalize and Launch',
      FOOTER_SAVE:
        'Error: Please select the country and save as draft the projects',
    },
    MULTICOUNTRY: {
      LOCALE_ALREADY_EXISTS:
        'Error: The survey already exists in the Multi-Country group for locale <LOCALE>. Try again with another locale.',
      MANUAL_PROCESSING_APPLYING_TEMPLATE:
        'Please, click `Save and Process` before applying the Template',
    },
    Quota: {
      STATUS_CHANGED_ERROR_MESSAGE: 'one or more Quotas cannot be changed!',
    },
    SUPPLIER_GROUP: {
      EDIT_SUPPLIER_GROUP:
        'In order to change existing Supplier Group, please use the edit icon next to the group.',
      SUPPLIER_GROUP_MORE_THAN_ONE:
        'Supplier group should have more than one Supplier',
      CONFIRM_SUPPLIER_CPI_FOR_GROUP: 'CPI value must be confirmed',
      CPI_REQUIRE: 'CPI is required',
      GROUP_NAME_REQUIRE: 'Group Name is required',
      INVALID_GROUP_NAME:
        'Supplier Group Name should contain only letters, numbers, symbols (-, _, @) and should not exceed 28 chars',
      INVALID_CUSTOM_ALLOCATION:
        'The sum of Allocation % for suppliers should equal 100% for the Group',
      INDIVIDUAL_ALLOCATION_OUT_OF_LIMIT:
        'The Supplier Allocation value should be less than or equal to 100%',
      INDIVIDUAL_ALLOCATION_ZERO:
        'The Supplier Allocation values should be greater than 0%',
    },
    SUPPLIER_RATE_CARD: {
      INVALID_CSV_FILE:
        "This CSV file won't work. Please use the template, provided below and try again.",
      FORMULA_SAVED_ERROR:
        'Please make sure to provide all required information before proceeding.',
    },
    DRAFT_SURVEY_DELETE: 'Error: The draft survey could not be deleted.',
    SUPPLIER_BLEND: {
      TITLE_REQUIRED: 'Title is required to save Blend',
      TITLE_INVALID:
        'Title should contain only letters, numbers, symbols (-, _, @)',
    },
    SUPPLIER_GROUP_TEMPLATE_NOT_SAVED:
      'Error: Unable to save this group template. Please refresh and try again.',
    NIGHTCRAWLER: {
      BUYER_INFO_UNAVAILABLE:
        'Error:  Unable to retrieve buyer information. Please refresh and try again',
      UNABLE_TO_SYNC:
        'Error:  Unable to sync survey. Please refresh and try again',
      MISSING_REDIRECT_SETTINGS:
        'Error:  Buyer redirect settings missing. Please update to continue',
      INCORRECT_SURVEY_ENTRY_LINK:
        'Error:  Incorrect survey entry link. Please update to continue',
      INVALID_BUYER_ENTRY_LINK:
        'Links must contain a placeholder for the transaction id to be valid. For example, "https://yoursurvey.com/surveyId?transaction_id=[%%buyer_transaction_id%%]&session_id=[%%supplier_session_id%%]"',
    },
    SUPPLIER_PAYLOAD: {
      FLEXIBILITY_GREATER_THAN_HUNDRED:
        'Error:  Flexibility cannot be greater than 100%. Please update to continue',
      CPI_VALUE_CONFIRMED: 'CPI value must be confirmed',
      ALLOCATION_LESS_THAN_COMPLETES:
        'Error:  Allocations must be greater than or equal to the number of completes. Please update to continue',
    },
    FEASIBILITY_PROCESSING: 'Error: Feasibility could not be processed',
    SOFT_LAUNCH_ERROR_MESSAGE:
      'Soft Launch and Field Evenly Over Time can not be applied at the same time on a project.',
    RECONTACT_RESPONDENT_LIST:
      'Error:  Respondent list must be uploaded before testing. Please update to continue',
    QUESTION_LIBRARY: {
      QUESTION_TEXT_COPY: 'Problem in copying Question text! Please try again.',
    },
    ID_UPLOAD_ERROR: {
      CRM_UPDATE_ERROR: 'Error while updating CRM ID',
      ASANA_UPDATE_ERROR: 'Error while updating ASANA ID',
    },
    DOWNLOAD_REPORT_ERROR: 'Something went wrong! Please try again.',
    NO_PSIDS_FOUND: 'Error : There are no PSIDs for this selection.',
    TEMPLATES: {
      TEMPLATE_ADDITION_NOT_ALLOWED_IN_FOLDER:
        'Save the template in another folder or in a new folder.',
    },
    PO_CHARACTER_LIMIT_EXCEED:
      'The billing number cannot be longer than <MAX_CHAR> chars. Use a shorter number.',
    FEASIBILITY: {
      FEASIBILITY_NOT_PROCESSED:
        'Feasibility could not be processed at the moment, please contact support.',
      QUOTA_DISTRIBUTION_ERROR: (qualificationName?: string) => {
        return `Quota allocation for ${qualificationName} qualification is equal or less than zero. Please check and edit the quota allocation and save again.`;
      },
    },
    BILLING_NUMBER_MANDATORY: 'Billing number is mandatory!',
    PO_NUMBER_SPACES_NOT_ALLOWED:
      'Spaces are not permitted. Special Characters that are permitted are “{} [] () / ~ - , ; : . < >“.',
    PO_NUMBER_SPACE_NOT_ALLOWER_TITLE: 'INVALID RULE - Invalid Character',
    URL_SPACE_NOT_ALLOWED:
      'Please enter valid Live URL. The link entered has one or more space/s',
    COMPLETES_REQUIRED: {
      CANNOT_BE_ZERO: 'completes_required must be greater than 0',
    },
    MC_SINGLE_VIEW: {
      DELETING_LAST_TWO_CHILDREN_NOT_ALLOWED:
        'You can not delete the last two locales available. If you wish to delete the survey, use the button from Draft tab in Dashboard page.',
    },
    EDIT_CPI: {
      EMPTY_VALUE: 'New CPI value cannot be empty or 0.',
    },
    UNIQUE_LINKS_REQUIRED: {
      DRAFT:
        'The goal and/or IR is different than initial setup and now the unique buyer entry links file should be greater than <QUANTITY>. Decrease the ‘completes’ target, clear the buyer entry link from "Finalize & Launch” page and set the new target again.',
      LIVE: 'The goal and/or IR is different than initial setup and now the unique buyer entry links file should be greater than <QUANTITY>. Upload a new buyer entry link from “Edit Details“ before making this edit.',
    },
    AIDA: {
      LIVE_QUOTA_CHANGE_RESTRICTION:
        'Quota selected cannot be changed/deleted. You can still change the quota not selected in AIDA™ (AI Delivery Assistant).',
      LIVE_CPI_OVERRIDE_CHANGE:
        'Price Override cannot be lower than <CURRENCY_SYMBOL><CPI_VALUE>. To set your price, disable AIDA™ (AI Delivery Assistant) and set the price again.',
      REMOVE_UNICORN_QUOTAS:
        'An improbable Quota has been detected. Remove the improbable quota.',
      QUOTA_LOCK_RESTRICTION:
        'Quota Locking is restricted while AIDA™ is running.',
      CT_CO_RESTRICTION: 'CT/CO is restricted while AIDA™ is running.',
    },
    UNIQUE_BUYER_LINKS: {
      UPLOAD_UNIQUE_LINKS:
        'Please upload unique buyer entry links greater than or equal to <expectedLinks>',
    },
    MULTI_QUOTA_NESTING: {
      KEEP_AT_LEAST_ONE_QUOTA:
        'You cannot delete all the quotas nested. Keep at least one.',
      DUPLICATE_QUOTAS_IN_NEW_NESTING:
        'Some of the quotas in the new nesting are already present in <MATCHED_NESTING>. Please check and try again!',
      DUPLICATE_QUOTAS_BETWEEN_NESTINGS:
        'There are some duplicate quotas between <NESTING_1> and <NESTING_2>. Please check and try again!',
      AT_LEAST_TWO_SELECTIONS_REQUIRED:
        'Please select more than one quota. A minimum of 2 options is required.',
      CANT_GROUP_ALL_CONDITIONS_IN_SINGLE_GROUP:
        'You cannot select all conditions in a single Group. Please un-check one quota and create another Group.',
      MORE_QUOTAS_THAN_COMPLETES:
        'There are more quotas than completes available. Some nested quotas have 0 quantity available. This may cause unexpected behavior - please revise nested quotas if this warning is unexpected.',
      INVALID_QUOTA_COMPLETE:
        "The total number of completes allocated in the quotas doesn't equal the total number of completes remaining.",
    },
  },
  warningMessage: {
    NO_FILE: 'Please select a file before proceeding.',
    INCORRECT_FILE_FORMAT:
      'This file is in the incorrect format. Please see the example file.',
    COMPLETE_REQUIRED: `Please complete all required fields.`,
    CENSUS: {
      COMPLETE_REQUIRED: `Please complete all required fields. Census Percentage is missing.`,
      INCORRECT: `You have used an incorrect Census Percentage, please correct this before saving.`,
    },
    DAILY_STATISTICS: {
      COUNTRY_REQUIRED: `Please select the country.`,
      DATERANGE_REQUIRED: `Please select the date range`,
    },
    INVALID_RANGE: {
      MIN_GREATER_THAN_MAX: `You have entered an invalid range. #FROM VALUE# should be less then #TO VALUE#. Please correct this before saving.`,
      OVERLAPPING: `You have entered an invalid range. The input are overlapping. Please correct this before saving.`,
      OVERLAPPING_FROM: `You have entered an invalid range. #FROM VALUE# is overlapping with existing ranges. Please correct this before saving.`,
      OVERLAPPING_TO: `You have entered an invalid range. #TO VALUE# is overlapping with existing ranges. Please correct this before saving.`,
    },
    EPC_REPORT: {
      DATERANGE_COMPANY_REQUIRED:
        'Error:  Please select company and date range to continue',
    },
    INCOMPLETE_FIELDS: 'Please enter all fields.',
    NO_COMPANIES_FOUND:
      'Warning: No companies found. Please update to continue',
    COMMON_NO_RECORD_FOUND: 'Warning:  No record found',
    LAUNCH_SURVEY: {
      SURVEY_REMOVE_FROM_PRISTINEGROUPING: `Removing surveys from this list is not recommended, as it may allow respondents who previously completed surveys to take the surveys again`,
      BILLING_CODE_ALREADY_USED:
        'This BILLING CODE has already been used for another invoiced surveys.',
    },
    QUOTA_MODAL: {
      MISSING_NO_OF_COMPLETE:
        'Please specify total number of completes before setting quotas.',
      INVALID_QUOTA_COMPLETE:
        "The total number of completes allocated in the quotas doesn't equal the total number of completes remaining.",
      INVALID_RANGE:
        'Value must be greater than the minimum and less than maximum. Please update to continue.',
    },
    MULTICOUNTRY_DRAFT: {
      SELECT_MULTICOUNTRY: 'Please select multicountry row',
    },
    QUOTA: {
      SELECT_QUOTA_LOCK_UNLOCK: 'Please Select the Quota to Lock/Unlock',
      MAXIMUM_QUOTAS_TO_NEST:
        'You may only nest a maximum of :NESTED_QUOTA_LIMIT qualifications at a time',
    },
    COUNTRY_CHANGE: {
      LOST_QUALIFICATIONS:
        'The new country doesn’t support <QUALIFICATIONS_NAME> qualifications applied before, therefore are removed.',
    },
    GROUPING_SINGLE_QUOTA: 'alert 3 : Grouping for single Quota not allowed',
    GROUPING_CENSUS_REPO: 'Quota Grouping is not allowed over Census Repo',
    QUESTION_LIBRARY: {
      ENTER_ALL_FIELDS: 'Please fill all required fields',
      REQUIRED_ANSWER_OPTIONS: 'Please enter Answers Options Id and Text',
      DUPLICATE_LOCALE: 'Screener Question already exist for this locale',
      REQUIRED_RESPID: '%%respId%% required in Question Screener Text',
      CORE_QUESTION_NOT_ALLOWED: 'Creating Core Class Question is not allowed',
      ADD_LOCALIZATION: 'Please add localization',
      REQUIRED_STEM_RESPID: '%%respId%% required in stem1',
      REQUIRED_ANSWER_TRANSLATION: 'Please add translation for Answers Options',
      REQUIRED_COMPONENT_TYPE: 'Please add component type',
    },
    COMPLETES_AND_INCIDENCE_REQUIRED:
      'Warning:  Please add Completes and Incidence to continue',
    UNSUPPORTED_PARENT_QUALIFICATION:
      'You are attempting to add a qualification having a dependency that we currently do not support in our system. Please check your selection and try again.',
    TRAFFIC_CHANNEL_MODAL: {
      QBP_QUOTA_OPTION_NOT_SELECTED:
        'This survey has Quota Based Pricing enabled and requires that you assign a Traffic Channel to a quota.',
      AIDA_QUOTA_OPTION_NOT_SELECTED:
        'This survey has AIDA™ enabled and requires that you assign a Traffic Channel to one of the quota.',
    },
    NO_LOCATION: 'No location qualifications/quotas to clear',
    SUPPLIER_GROUP: {
      DISABLE_CPI_OVERRIDE: 'Disable the CPI Override, to customise the CPI',
    },
    BUYER_SETTINGS: {
      KEY_OR_PRIVATE_KEY_MISSING:
        'Shared private key and key name cannot be missing. Please update to continue',
    },
    FILE_UPLOAD_MISSING: 'File must be uploaded to continue',
    INVALID_FILE_EXTENSION:
      'Please upload file in <FILE_EXTENSION> format to continue',
    TEMPLATES: {
      TEMPLATE_MODIFICATION_NOT_ALLOWED:
        'This template cannot be updated because you are not the owner. Please Save as new template.',
      TEMPLATE_DOES_NOT_HAVE_BUYER_CPI:
        'The template doesn’t have Buyer CPI, make sure to add before launching',
    },
    INVALID_NUM_OF_COMPLETES:
      'Completes can not be set lower than Total Fielded.',
    OPERATOR_SETTINGS: {
      GLOBAL_SETTINGS: {
        DYNAMIC_PROFILER_MAXIMUM_QUESTIONS:
          'Max Number Of Questions is not valid',
        DATA_QUALITY_QUESTION_INVALID_VALUE:
          'Please enter a value more than 0 for Data Quality Question',
        TLQ_QUESTION_INVALID_VALUE:
          'Please enter a value more than 0 for Terminate Low Quality Questions',
      },
    },
    RACE_QUALIFICATION_REMOVED:
      'This Draft has been updated to remove targeting and/or quotas for Race (214).  If you still need this targeting you can add it back in using the Advanced Targeting Question “Race (Hispanic Included).”',
    MULTICOUNTRY: {
      MANUAL_PROCESSING_BROWSE_ANOTHER_COUNTRY:
        'Please, click `Save and Process` before browsing to another Country/Locale.',
    },
    FEASIBILITY: {
      UNUSED_CRITERIA:
        'You have selected a Criteria that is in need of a feasibility update and has not been included in the calculation of survey Feasibility. We have notified the responsible teams and your account representative that <QUALIFICATIONS_NAME> needs to be updated. They will be in touch as soon as it is updated.',
    },
    EXCLUSION: {
      REMOVE_SURVEY_NUMBER:
        'Removing a survey number will automatically reset the date range.',
      CHANGING_DATE: 'Survey grouping is changing if you use the date range.',
      REMOVE_EXCLUSION_ALERT:
        'There is no exclusion list created. Use the Filtered Audience section to select the survey to exclude or include.',
    },
    DECIPHER: {
      FETCH_MISSING_MARKER_FAILED:
        'Error in fetching unmapped decipher quota markers.',
    },
    QUOTA_RESET_ON_COUNTRY_CHANGE:
      "The new country doesn't have the same qualifications and/or conditions, therefore any qualification/quota are reset.",
    MISS_MATCH_SUPPLIERS:
      'Alert: The Supplier Blend applied to this survey included Suppliers that are not eligible for this survey.  Please review your Supplier allocations to ensure they meet your requirements for the project.',
    DEFAULT_BLEND_NOT_APPLIED:
      'The chosen Blend does not have Allocations for Suppliers eligible for this survey.  Please review the Suppliers available on this survey and choose a Blend with eligible Suppliers with Allocations, or update the chosen Blend.',
    QUALIFICATIONS_NOT_AVAILABLE_FOR_MC:
      'This qualification is not available for some of the locales selected.\nPlease re-set the quotas by selecting the following locale.\n<COUNTRY_AND_LANGUAGE>',
    RANGE_NOT_AVAILABLE_FOR_MC:
      'The quota has not been applied to the following country due to the different ranges. <COUNTRY_AND_LANGUAGE>',
    MC_SINGLE_VIEW: {
      LOCALE_QUOTA_MODAL: {
        INVALID_INPUT: 'Invalid! Please enter an appropriate value.',
        TOTAL_MISMATCH:
          "The total number of completes allocated for these locales doesn't equal the total number of completes remaining.",
      },
    },
    INACTIVE_QUALIFICATION: {
      SURVEY_UPDATE:
        'One or more qualification/s used in the original survey is/are no longer active or has been changed.<br><INACTIVE_QUAL_LIST><br>The survey might not have the original qualifications anymore.',
      SURVEY_CLONE:
        'One or more qualification/s used in the original survey is/are no longer active or has been changed.<br><INACTIVE_QUAL_LIST><br>The new cloned survey will be created without this/these qualification/s.',
    },
    GOAL_CHANGE:
      'You have changed your survey Goal. Please review your Supplier Allocations as they may not match your previous settings.',
    MULTI_QUOTA_NESTING: {
      EMPTY_TITLE: 'Quota Nesting Title cannot be empty.',
      DUPLICATE_TITLE:
        'Quota Nesting Title <NESTING_NAME> already exists. Try again with a different title.',
      INVALID_TITLE:
        'The nested title contains not allowed character/s. Use letters, numbers, and these symbols !%&*(){}[]|\\/<>=+-_.',
    },
  },
  successMessage: {
    SIMILAE_SURVEYS_SEARCH_COMPLETE: 'Similar survey search is complete.',
    FILE_ADDED: 'File added successfully',
    LOGOUT_SUCCESS: 'Logout Successfully',
    PSID_CLEAR_SUCCESS: 'PSID cleared successfully',
    SUCCESSFULL_SAVED: 'Successfully SAVED!',
    SURVEY_ADDED: 'Survey successfully saved',
    SURVEY_UPDATED: 'Success! Survey data has been updated',
    SUPPLIER_GROUP_TEMPLATE_SAVED: 'Supplier group template saved successfully',
    SUPPLIERS_UPDATED: 'Suppliers Updated.',
    HAS_MODIFIED_LOCATION_CODE:
      'successfully uploaded. Some Lines Were Modified Because They Were Only 4 or 3 Digits Long',
    RIGHT_LOCATION_CODE: 'successfully uploaded',
    DUPLICATED_SKIPPED: 'duplicate <QUALIFICATION_NAME> skipped.',
    LOCATION_CLEARED: 'cleared successfully',
    BUYER_SETTINGS: {
      VARIABLE_MAPPING: {
        SAVE_SETTING: 'Success! Buyer information has been added',
      },
    },
    ADV_QUESTION_ADDED: 'Success! Successfully Added',
    ADV_QUESTION_REMOVED: 'Success! Target has been removed',
    SURVEY_DETAIL_QUOTA: {
      QUOTA_LOCKED: 'Quota Locked',
      QUOTA_UNLOCKED: 'Quota Unlocked',
    },
    MULTICOUNTRY_DRAFT: {
      SAVED_SUCCESS: 'All surveys selected are saved as draft',
      LAUNCH_SUCCESS: 'All surveys are successfully launched',
      NEW_SURVEY_ADDED: 'Success! New Survey Added',
      NEW_SURVEYS_ADDED: 'Success! New Surveys are Added',
      SURVEY_DELETED: 'Survey removed and deleted successfully',
    },
    MULTICOUNTRY_SINGLE_VIEW: {
      CREATED_SUCCESSFULLY: 'Success! The survey has been created.',
      DELETED_SUCCESSFULLY: 'Locale removed and deleted successfully',
    },
    DRAFT_SURVEY_DELETED: 'Success! Draft survey has been deleted.',
    DRAFT_SURVEYS_DELETED: 'Success! Draft surveys have been deleted.',
    QUOTA_MODAL: {
      QUOTA_ADDED: '<QUALIFICATION_NAME> Quota Added',
    },
    SUPPLIER_RATE_CARD: {
      FORMULA_SAVED_SUCCESS: 'Success! Rate card has been saved',
    },
    QUESTION_LIBRARY: {
      QUESTION_ADDED: 'Question Added Successfully',
      QUESTION_UPDATED: 'Question Updated Successfully',
      QUESTION_DELETED: 'Question Deleted Successfully',
      LOCALIZATION_ADDED: 'Localization Added Successfully',
      LOCALIZATION_DELETED: 'Localization Deleted Successfully',
      ANSWER_OPTION_ADDED: 'Answers Options Added',
      ANSWER_OPTION_DELETED: 'Answers Options Deleted',
      QUESTION_TEXT_COPIED: 'Question text copied!!',
    },
    CPI_UPDATED: 'Success! CPI has been updated',
    MARGIN_UPDATED: 'Success! Margin has been updated',
    MARGIN_FAILED_UPDATED: 'Error while updating survey margin',
    PROJECT_OPERATOR_REMOVED: 'Success! Project Manager removed successfully',
    PROJECT_OPERATOR_ASSIGNED: 'Success! Project Manager assigned successfully',
    BUYER_PROJECT_MANAGER_REMOVED:
      'Success! Buyer Project Manager removed successfully',
    BUYER_PROJECT_MANAGER_ASSIGNED:
      'Success! Buyer Project Manager assigned successfully',
    CLEAR_RESPONDENT_LIST: 'Success! PSID has been cleared.',
    OPERATOR_SETTINGS: {
      CRM_ID: {
        FILE_UPLOADED: 'Uploaded CRM ID',
      },
      GLOBAL_SETTINGS: {
        SETTINGS_SAVED: 'Successfully SAVED!',
      },
    },
    TEMPLATES: {
      TEMPLATE_SAVED: 'Template saved successfully',
      TEMPLATE_UPDATED: 'Template updated successfully',
      TEMPLATE_FOLDER_SAVED: 'Template Folder saved successfully',
    },
    CPI_FEASIBILITY_ALREADY_UPDATED:
      'The CPI and Feasibility is already updated with the latest changes. Click ”Save as Draft” to continue.',
    BASIC_TOKEN_SAVED: 'Token has been saved successfully.',
    BILLING_NUMBER_UPDATED:
      'Success! Billing PO/Project Number has been updated',
    RECONTACT_SURVEY: {
      UPDATED: 'Recontact survey updated',
    },
    MC_QUOTA: {
      ALL_SURVEY_QUOTA_APPLIED: 'Quota applied for all locales',
      ALL_SURVEY_CENSUS_APPLIED: 'Census quota applied for all locales',
      ALL_SURVEY_QUOTA_DELETED: 'Quota deleted for all locales',
    },
    SINGLE_QUOTA: {
      QUOTA_APPLIED: 'Quota applied only for this locale',
      CENSUS_APPLIED: 'Census quota applied only for this locale',
      QUOTA_DELETED: 'Quota deleted only for this locale',
    },
    NEW_COUNTRY_ADD_MCQB_CONFIRMATION:
      'New locale add, please check the quota per locale before launch the survey.',
    CPI_APPLIED: 'CPI applied successfully',
    MULTI_QUOTA_NESTING: {
      APPLIED_SUCCESSFULLY:
        '<NUMBER_OF_QUOTA_NESTING> Quota Nesting applied successfully',
      NO_QUOTA_APPLIED_FOR_SURVEY: 'No Quota Nesting applied for this survey',
    },
  },

  infoMessage: {
    TEMPLATE: {
      NOT_AVAILABLE_FOR: {
        MC_SINGLE_VIEW:
          'Template for Multi-country Single Survey view is not available now. You can continue to created template for Traditional Multi-country (Or Multi Survey) and Single survey',
      },
    },
    MC_SINGLE_VIEW: {
      COMPLETES_CHANGED_FOR_ALL: 'Completes value changed for all locales',
      CLONE_MC_SVP_NOT_AVAILABLE:
        'CLONE a Multi-country Single Survey view is not available now. We will add this functionality soon.',
    },
    FILE_UPLOAD_IN_PROCESS: 'Your file is uploading and being processed.',
  },

  surveyDetailErrorMessage: {},
  OUT_OF: 'out of',

  TRAFFIC_CHANNEL_SURVEY_CREATED_SUBPART:
    'Traffic Channel Survey Created for Survey',
  CPI_CONFIRMATION_ERROR:
    'You need to either confirm the Price warning notification or set the CPI lower than 10.',
  CPI_PAUSE_THRESHOLD_WARNING: `
      <p>The Pause Threshold you entered was not saved.</p>
      <p>To successfully save a pause threshold, you must enter a pause CPI greater than the average CPI of the enabled suppliers.</p>
      <a class="btn btn-secondary" href="https://purespectrum.helpjuice.com/en_US/create-and-launch-a-survey/review-and-update-cpi-and-suppliers#set-survey-pause-threshold-5" target="__blank">Learn More</a>`,
};
